"use client";
import React, { ReactNode, memo } from "react";
import {
  Box,
  BoxProps,
  InputLabel,
  InputLabelProps,
  TextFieldProps,
} from "@mui/material";
import {
  Control,
  Controller,
  ControllerProps,
  FieldErrors,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";
import AppTextField from "../AppTextField";
import AppFromLabelField from "./AppFromLabelField";

const AppFormControlTextField = <T extends FieldValues>({
  label,
  control,
  name,
  controlProps,
  labelProps,
  textfieldProps,
  onChangeValueForm,
  classNameContainer,
  rules,
  helper,
  childrenWrapperProps,
}: AppFormControlTextFieldProps<T>) => {
  return (
    <AppFromLabelField
      label={label}
      labelProps={{
        ...labelProps,
      }}
      className={classNameContainer}
      required={labelProps?.required}
      helper={helper}
      childrenWrapperProps={childrenWrapperProps}
    >
      <Controller
        control={control}
        name={name}
        rules={{ ...rules }}
        {...controlProps}
        render={({
          field: { onChange, ...otherFieldProps },
          fieldState: { error: errorField },
        }) => (
          <AppTextField
            onChange={(event) => {
              onChange(event);
              if (onChangeValueForm instanceof Function)
                onChangeValueForm(event);
            }}
            {...otherFieldProps}
            error={!!errorField}
            helperText={
              <>
                {errorField
                  ? errorField?.message
                    ? errorField?.message
                    : ""
                  : ""}
              </>
            }
            {...textfieldProps}
          />
        )}
      />
    </AppFromLabelField>
  );
};

export type AppFormControlTextFieldProps<T extends FieldValues> = {
  label?: string | ReactNode;
  control: Control<any>;
  name: FieldPath<T>;
  controlProps?: Omit<ControllerProps, "render" | "name" | "control">;
  labelProps?: InputLabelProps;
  textfieldProps?: Omit<TextFieldProps, "onChange">;
  onChangeValueForm?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  classNameContainer?: string;
  rules?: RegisterOptions;
  helper?: string | ReactNode;
  childrenWrapperProps?: BoxProps;
};

export default memo(AppFormControlTextField);
